// extracted by mini-css-extract-plugin
module.exports = {"footer":"ModalFooter_footer__79ruE","buttonWrapper":"ModalFooter_buttonWrapper__6ft4p","rejectButton":"ModalFooter_rejectButton__mwkBL"};